import { useEffect, useRef } from 'react'

const Watermark = ({ username, higher }) => {
  const watermarkRef = useRef(null)

  useEffect(() => {
    // 自動抓父容器
    const container = watermarkRef.current?.parentElement
    if (!container) return

    // 避免重複添加
    let watermarkDiv = container.querySelector('.watermark')
    if (!watermarkDiv) {
      watermarkDiv = document.createElement('div')
      watermarkDiv.className = 'watermark'
      watermarkDiv.style.position = 'absolute'
      watermarkDiv.style.top = 0
      watermarkDiv.style.left = 0
      watermarkDiv.style.width = '100%'
      watermarkDiv.style.height = '100%'
      watermarkDiv.style.pointerEvents = 'none'
      watermarkDiv.style.zIndex = 2
      watermarkDiv.style.opacity = 0.12

      container.style.position = 'relative'
      container.appendChild(watermarkDiv)
    }

    const canvas = document.createElement('canvas')

    if (higher) {
      canvas.width = 270
      canvas.height = 320
    } else {
      canvas.width = 230
      canvas.height = 380
    }

    const ctx = canvas.getContext('2d')
    if (!ctx) return

    ctx.rotate((-18 * Math.PI) / 180)
    ctx.font = "24px 'Noto Sans', 'Arial', 'Helvetica', sans-serif"
    ctx.fillStyle = 'black'

    if (higher) {
      ctx.fillText(username, 55, 80)
      ctx.fillText(username, 50, 130)
    }
    ctx.fillText(username, 45, 180)
    ctx.fillText(username, 40, 230)
    ctx.fillText(username, 35, 280)
    ctx.fillText(username, 30, 330)

    watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL()})`
    watermarkDiv.style.backgroundRepeat = 'repeat'
    watermarkDiv.style.backgroundPosition = 'center'
    watermarkDiv.style.backgroundSize = '150px 400px'

    // eslint-disable-next-line consistent-return
    return () => {
      if (container.contains(watermarkDiv)) {
        container.removeChild(watermarkDiv)
      }
    }
  }, [higher, username])

  // 只是一個空 div 用來掛 ref
  return <div ref={watermarkRef} />
}

export default Watermark
